<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow">
      <h2 class="text-2xl font-bold text-center">Change Password</h2>
      <div v-if="passwordExpired" class="p-3 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded">
        Your password has expired. Please set a new password to continue.
      </div>
      <form @submit.prevent="changePassword">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium" for="current_password">Old Password</label>
            <input
              id="current_password"
              v-model="current_password"
              class="w-full px-3 py-2 border rounded"
              type="password"
              required
            />
            <Field_Errors :received_errors="errors.current_password" />
          </div>
          <div>
            <label class="block text-sm font-medium" for="new_password">New Password</label>
            <input
              id="new_password"
              v-model="new_password"
              class="w-full px-3 py-2 border rounded"
              type="password"
              required
            />
            <Password_Requirements :password="new_password" />
            <Field_Errors :received_errors="errors.new_password" />
          </div>
          <div>
            <label class="block text-sm font-medium" for="new_password_confirm">Confirm New Password</label>
            <input
              id="new_password_confirm"
              v-model="new_password_confirm"
              class="w-full px-3 py-2 border rounded"
              type="password"
              required
            />
            <Field_Errors :received_errors="errors.new_password_confirm" />
          </div>
        </div>
        <div class="flex items-center justify-between mt-6">
          <Field_Errors :received_errors="errors.non_field_errors" />
          <button
            class="btn-primary"
            :disabled="!isPasswordConfirmMatch"
            type="submit"
          >
            Confirm
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';

import Field_Errors from '@/components/widgetcomponents/Field_Errors.vue'
import Password_Requirements from '@/components/widgetcomponents/Password_Requirements.vue'
import { AllauthError, makeAllauthRequestAndParseErrors } from '@/utils/auth';

export default {
  components: {
    Field_Errors,
    Password_Requirements,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      current_password:'',
      new_password:'',
      new_password_confirm:'',
      errors: {},
    }
  },
  computed: {
    passwordExpired() {
      return this.$store.getters['auth/passwordExpired'];
    },
    isPasswordConfirmMatch() {
      return this.new_password === this.new_password_confirm;
    }
  },
  methods: {
    async changePassword() {
      try {
        this.errors = {}
        const response = await makeAllauthRequestAndParseErrors({
          method: 'post',
          url: '_allauth/browser/v1/account/password/change',
          data: {
            current_password: this.current_password,
            new_password: this.new_password,
          },
        })
        if (response.status === 401) {
          throw new AllauthError({ non_field_errors: ['Not authenticated']})
        }
        this.toast.success('Password updated')
        await this.$store.dispatch('auth/fetchUser')
        this.$router.push('/')
      } catch (error) {
        if (error.fieldBasedErrors) {
          this.errors = error.fieldBasedErrors
        } else {
          throw error
        }
      }
    },
    setPasswordConfirmErrors() {
      if (this.isPasswordConfirmMatch) {
        this.errors.new_password_confirm = [];
      } else {
        this.errors.new_password_confirm = ['New password and confirmation do not match'];
      }
    }
  },
  watch: {
    new_password() {
      this.setPasswordConfirmErrors();
    },
    new_password_confirm() {
      this.setPasswordConfirmErrors();
    }
  }
}
</script>
